import { render, staticRenderFns } from "./visPieList.vue?vue&type=template&id=061ecb20"
import script from "./visPieList.vue?vue&type=script&lang=js"
export * from "./visPieList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports